import { useIntl } from '@umijs/max';
import { ModalType, useModal } from '../useModal';

export const useDeleteConfirm = <TResult>(
  okAction?: (params: TResult) => Promise<any>,
) => {
  const intl = useIntl();

  return useModal(
    ModalType.confirm,
    intl.formatMessage({
      id: 'modal.delete.title',
      defaultMessage: 'Bạn có chắc chắn muốn xoá?',
    }),
    okAction,
  );
};
